import FormControl, { FormControlProps } from "react-bootstrap/FormControl";

import "./styles.css";

type Props = FormControlProps;

export function FormattedControl({ ...rest }: Props) {
	return <FormControl className="form-control-border" {...rest} />;
}
